import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Head from '@/components/HelloWorld.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import './lib/rem.js'
import * as filters from './filters'


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.use(Vant)
Vue.use(Head)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
